import { Box, Avatar, Typography, CircularProgress } from '@material-ui/core'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import { FunctionComponent } from 'react'
import styled from 'styled-components/macro'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { ProfileStatusBar } from './ProfileStatusBar'
import { observer } from 'mobx-react'
import profileState from 'models/profile-store/profile.store'

const StyledLabel = styled(Box)`
  overflow: hidden;
  max-width: 11ch;
  text-overflow: ellipsis;
  white-space: nowrap;
  && {
    .MuiTypography-root {
      align-self: center;
    }
  }
`
const StyledKeyboardArrowDownIcon = styled(KeyboardArrowUp)`
  && {
    margin: 0em 0em -0.4em 0em;
    fill: ${props => props.theme.colors.accent1};
  }
`

const StyledKeyboardArrowUpIcon = styled(KeyboardArrowDown)`
  && {
    margin: 0em 0em -0.4em 0em;
    fill: ${props => props.theme.colors.accent1};
  }
`

const CustomCircularProgress = styled(CircularProgress)`
  & * {
    stroke: ${props => props.theme.colors.supplementary1} !important;
  }
`

interface ProfileStatusProps {
  percentage: number
  avatar: string
  name: string
  hideAvatar?: boolean
  setDropDownOff?: boolean
  hideDropArrow?: boolean
  onClick?: (event?: any) => void
}

const ProfileStatusComponent: FunctionComponent<ProfileStatusProps> = ({
  percentage,
  avatar,
  name,
  hideAvatar,
  hideDropArrow,
  onClick
}) => {
  const theme = useTheme()
  const { isDevice } = useScreenSizes()

  const toggleArrow = () => {
    profileState.setisMenuOpen(!profileState.isMenuOpen)
    onClick
  }

  const size = 44

  return (
    <Box display="flex" flexDirection="column" width="100%" onClick={toggleArrow}>
      {!hideAvatar && !isDevice && (
        <Box display="flex" flexDirection="row">
          <Box alignSelf="center" mr="0.5em">
            <Avatar src={avatar} />
          </Box>
          <Box m="0" display="flex" flexDirection="column" width="100%">
            <Typography variant="body2" component="span">
              <StyledLabel color={theme.colors.accent1} fontWeight="bold" alignSelf="center" textAlign="left">
                {name}
              </StyledLabel>
            </Typography>
            <Typography variant="caption" component="span">
              <Box color={theme.colors.accent1} textAlign="left">
                <Box style={{ display: 'inline', marginRight: '.25em' }}> {Math.round(percentage)}%</Box>
                <Box style={{ display: 'inline' }}>complete</Box>
                {!hideDropArrow &&
                  (profileState.isMenuOpen ? <StyledKeyboardArrowUpIcon /> : <StyledKeyboardArrowDownIcon />)}
              </Box>
            </Typography>
          </Box>
        </Box>
      )}
      {isDevice && (
        <Box display="flex" flexDirection="row">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mr="0.5em"
            position="relative"
            width={size}
            height={size}
          >
            <Avatar src={avatar} style={{ zIndex: 50 }} />
            <CircularProgress
              variant="determinate"
              value={percentage}
              size={size}
              thickness={4}
              style={{
                position: 'absolute',
                top: '0%',
                left: '0%',
                zIndex: 100
              }}
              color="primary"
            />
            <CustomCircularProgress
              variant="determinate"
              value={100}
              size={size}
              thickness={4}
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                zIndex: 50
              }}
            />
          </Box>
          <Box display="flex" justifyContent="space-between" flexDirection="column">
            <Typography variant="body2" component="span">
              <StyledLabel color={theme.colors.accent1} fontWeight="bold" alignSelf="center" textAlign="left">
                {name}
              </StyledLabel>
            </Typography>
            <Box m="0" display="flex" flexDirection="column" width="100%">
              <Typography variant="caption" component="span">
                <Box color={theme.colors.accent1}>
                  <Box style={{ display: 'inline', marginRight: '.25em' }}> {Math.round(percentage)}%</Box>
                  <Box style={{ display: 'inline' }}>complete</Box>
                  {!hideDropArrow &&
                    (profileState.isMenuOpen ? <StyledKeyboardArrowUpIcon /> : <StyledKeyboardArrowDownIcon />)}
                </Box>
              </Typography>
              {!isDevice && <ProfileStatusBar hideAvatar={hideAvatar} percentage={percentage} />}
            </Box>
          </Box>
        </Box>
      )}
      <Box m="0" display="flex" flexDirection="column" width="100%">
        {!isDevice && <ProfileStatusBar hideAvatar={hideAvatar} percentage={percentage} />}
      </Box>
    </Box>
  )
}

export const ProfileStatus = observer(ProfileStatusComponent)
